import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("hreye_user") || "null");
    } catch { return null; }
  });
  const [settings, setSettings] = useState({
    software_name: "Qrew HR",
    tagline: "Smart HR. Stronger Teams.",
    logo_initial: "HE",
    primary_color: "#0F172A",
    accent_color: "#06B6D4",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("hreye_token", data.token);
      localStorage.setItem("hreye_user", JSON.stringify(data.user));
      setUser(data.user);
      return data.user;
    } finally { setLoading(false); }
  };

  const googleLogin = async (email, full_name) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/google", { email, full_name });
      localStorage.setItem("hreye_token", data.token);
      localStorage.setItem("hreye_user", JSON.stringify(data.user));
      setUser(data.user);
      return data.user;
    } finally { setLoading(false); }
  };

  const logout = () => {
    localStorage.removeItem("hreye_token");
    localStorage.removeItem("hreye_user");
    setUser(null);
    window.location.href = "/login";
  };

  const refreshSettings = async () => {
    const r = await api.get("/settings");
    setSettings(r.data);
  };

  // Apply runtime theme (palette / font) from org settings
  useEffect(() => {
    if (!settings) return;
    const body = document.body;
    if (settings.theme_palette) body.setAttribute("data-theme", settings.theme_palette);
    if (settings.font_family) body.style.setProperty("--app-font", settings.font_family);
    if (settings.base_font_size) body.style.setProperty("--app-font-size", settings.base_font_size);
  }, [settings]);

  return (
    <AuthCtx.Provider value={{ user, setUser, settings, setSettings, refreshSettings, login, googleLogin, logout, loading }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
